
import {email, required, minLength} from "vuelidate/lib/validators";

import FormButton from "@/components/main/buttons/FormButton";
import isMob from "@/mixins/isMob";
import FormInput from "./FormInput";
import CheckBoxRed from "@/components/main/core/CheckBoxRed"
import DashModal from "@/components/dashboard/DashModal";
import "@/plugins/vuelidate"

export default {
  name: "SingInForm",
  mixins: [isMob],
  components: { FormButton, FormInput, CheckBoxRed, DashModal },
  data() {
    return {
      email: '',
      password: '',
      rememberMe: false,
      acceptTerms: false,
      test: false,
      isModal: false,
    }
  },
  validations: {
    password: {required, minLength: minLength(6)},
    email: {
      required,
      email: value => {
        if (/\s/.test(value)) {
          return false;
        }
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        return emailRegex.test(value);
      }
    },    
  },
  computed: {

    allOk() {
      return (
        this.email.length >= 4 && this.acceptTerms && !this.$v.email.$error

      )
    },

  },
  mounted() {
  },
  methods: {
    submit() {
      this.test = true
      let self = this;
      if (!this.$v.password.$error && !this.$v.email.$error && this.acceptTerms) {
        this.$axios.post(`${process.env.API_BASE_URL}/api/auth/password/email`, {
          email: this.email,
        })
          .then(function (response) {
            self.toggleModal(true)

          })

          .catch(function (error) {
            console.log('error: ' + error);
          });

      }

    },
    toggleModal(is) {
      this.isModal = is
    }
  },


}
